import type { CatalogRow } from '../domain/puntoEntregaModel.ts';
import type { PuntosEntregaRepositoryPort } from '../domain/ports/PuntosEntregaRepositoryPort.ts';
import type { PuntoEntregaLugarOrigen } from '../domain/puntoEntregaLugarOrigen.ts';

export type ComunaChangeSlice = {
  comunaId: number;
  lugaresOpt: ReadonlyArray<CatalogRow>;
  lugarId: number;
  lugarOrigen: PuntoEntregaLugarOrigen | '';
};

export function sliceCatalogAfterComunaChange(
  repo: PuntosEntregaRepositoryPort,
  comunaId: number,
): ComunaChangeSlice {
  if (comunaId <= 0) {
    return { comunaId: 0, lugaresOpt: [], lugarId: 0, lugarOrigen: '' };
  }
  return {
    comunaId,
    lugaresOpt: repo.listLugaresByComuna(comunaId),
    lugarId: 0,
    lugarOrigen: '',
  };
}
